module.exports = __webpack_public_path__ + "img/badges-app-store.e374ae72.svg";